export interface OptimisticMessage {
  id: string;
  type: 'user';
  content: string;
  created_at: string;
  isSending: boolean;
}

export interface Message {
  id: string;
  type: string;
  content: string;
  data?: any;
  created_at: string;
  elements?: any[];
  isExpanded?: boolean;
  is_terminal?: boolean;
}

/**
 * Progress updates («دارم باسلام رو جستجو میکنم…») are shown only while they are the latest thing the
 * agent said in a running turn; once the turn goes on, or when an old chat is reopened, they are hidden,
 * so the answer is not preceded by a stack of them.
 */
export const visibleMessages = <T extends { type: string; is_terminal?: boolean }>(
  messages: T[],
  isProcessing: boolean,
): T[] =>
  messages.filter(
    (message, index) =>
      !(message.type === 'agent' && message.is_terminal === false) ||
      (isProcessing && index === messages.length - 1),
  );

export const canSendChatMessage = (status: string): boolean =>
  status === 'finish' || status === 'failed';
